// extracted by mini-css-extract-plugin
export default {"detailWrapper":"ProductDetail_detailWrapper__6pl0H","loader":"ProductDetail_loader__PcYji"};